// frontend/src/pages/CustomerSettings.tsx
import React from 'react';

const CustomerSettings: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Settings</h1>
      <p>Account settings and notifications.</p>
    </div>
  );
};

export default CustomerSettings;